// Pure helpers split out of local-settings.effects.ts so they can be unit tested without pulling
// in `@angular/core` (which triggers the repo's pre-existing Jest .mjs transform failure on any
// spec that imports from the effects file directly).

export function resolveUserId(payloadUserId: string | number | undefined, state: any): string | null {
  if (payloadUserId != null) {
    return payloadUserId.toString();
  }
  const authedId =
    state && state.authentication && state.authentication.authenticatedUser
      ? state.authentication.authenticatedUser.user && state.authentication.authenticatedUser.user.id
      : null;
  return authedId != null ? authedId.toString() : null;
}

// Per-user fetch id keeps a rapid logout/login or user-switch from conflating two users' loads
// under a single dedup bucket. Same user repeatedly retrying still benefits from dedup; a
// different user's load runs independently.
export function buildSalesPlannerUserSettingsLoadId(
  payloadUserId: string | number | undefined,
  state: any
): string {
  const userId = resolveUserId(payloadUserId, state);
  return `salesPlanner-load-${userId || 'anon'}`;
}
